<script lang="ts">
  import * as Icons from 'lucide-svelte';
  import LySearch from './LySearch.svelte';
  import LyQuick from './LyQuick.svelte';
  import LyUser from './LyUser.svelte';
  import LySettings from './LySettings.svelte';
  import LyNavigation from './LyNavigation.svelte';
  import Dropdown from '../components/dropdown/Dropdown.svelte';
  import { BreakpointService } from '../services/BreakpointService.svelte';

  const Breakpoint = new BreakpointService();
</script>

<header class="LayoutHeader">
  <div class="LayoutFlex">
    {#if !Breakpoint.isGreater('large')}
      <div class="LayoutNavTrigger">
        <Dropdown icon={Icons.Menu} label="Menü öffnen" tag="div" align="left">
          <LyNavigation />
        </Dropdown>
      </div>
    {/if}
    <LySearch />
    <LyQuick />
    <LyUser />
    <LySettings />
  </div>
</header>

<style lang="scss">
  @use '../../styles/mixins';

  .LayoutHeader {
    .LayoutFlex {
      display: grid;
      gap: 1rem;
      grid-template-columns: auto 1fr auto auto auto;

      @include mixins.greaterLarge() {
        grid-template-columns: 1fr auto auto auto;
      }
    }

    .LayoutNavTrigger {
      --dropdown-panel-width: min(24rem, calc(100vw - var(--inset-abs) * 4));
    }
  }
</style>
